<template>
  <div>
    {{ label }}
    <v-tooltip
      v-if="information"
      bottom
      color="black"
      max-width="300"
      min-width="250"
    >
      <template #activator="{ on, attrs }">
        <v-icon
          small
          color="black"
          class="ml-1 hover-pointer"
          v-bind="attrs"
          v-on="on"
        >
          mdi-information
        </v-icon>
      </template>
      <div class="body-2 pt-4 d-flex">
        <v-icon
          small
          color="white"
        >
          mdi-information
        </v-icon>
        <div
          class="pl-2"
          v-html="information"
        ></div>
      </div>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: { label: { type: String, default: '' }, information: { type: String, default: '' } },
  mounted() {}
};
</script>
